module.exports = {
      id: "aquarius-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#aquarius",
      toString: function () {
        return this.url;
      }
    }